module.exports = __webpack_public_path__ + "static/media/06_variedades_mobile.cf0dac31.jpg";